export default __webpack_public_path__ + "static/media/video-dots.ded81d4e.svg";